import type { CopyCalculationFromRequestDto } from "./applications.requestsDto";

const controller = "applications";

export default {
  controller,
  byId: (id: number) => controller + "/" + id,
  calculations: (id: number) => controller + "/" + id + "/calculations",
  copyCalculationFrom: (dto: CopyCalculationFromRequestDto) =>
    controller + `/${dto.targetApplicationId}/calculations/${dto.targetCalculationId}/copy-from`,
  matching: (id: number) => controller + "/" + id + "/matching",
  recommendations: (id: number) => controller + "/" + id + "/recommendations",
  waitForUpdate: (id: number) => controller + "/" + id + "/wait-for-update",
  cargoPlanningStatus: (id: number) => controller + `/${id}/cargo-planning/status`,
  cargoPlanningEmbedLink: (id: number) => controller + `/${id}/cargo-planning/embed-link`,
  filterLite: controller + "/filter-lite",
  export: controller + "/export",
  lite: (id: number) => controller + "/" + id + "/lite",
  clientInfo: (id: number) => controller + "/" + id + "/client-info",
  aiAutofill: (id: number) => controller + "/" + id + "/ai-autofill",
  aiAutofillDocument: (id: number) => controller + "/" + id + "/ai-autofill/document",
  aiAutofillInput: (id: number) => controller + "/" + id + "/ai-autofill/input",
  salesIndicatives: controller + "/sales-indicatives",
};
